<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      // ==================== 响应式根字体配置 ====================
      //
      // 【核心公式】
      // 根字体 = 基准字体 × (当前屏幕宽度 / 设计稿宽度)
      //
      // 【不同设计稿配置参考】
      // ┌─────────────────────────────────────┐
      // │ 移动端设计稿 (750px)                  │
      // │ designWidth: 750,                    │
      // │ baseFontSize: 100,  // 1rem = 100px │
      // │ 优点：px转rem只需除以100，心算方便   │
      // │ 例：32px → 0.32rem, 100px → 1rem    │
      // ├─────────────────────────────────────┤
      // │ PC端设计稿 (1920px) ← 当前使用       │
      // │ designWidth: 1920,                   │
      // │ baseFontSize: 16,   // 1rem = 16px  │
      // │ 优点：符合浏览器默认值，开发直观     │
      // │ 例：32px → 2rem, 24px → 1.5rem      │
      // ├─────────────────────────────────────┤
      // │ 超宽屏设计稿 (2560px)                 │
      // │ designWidth: 2560,                   │
      // │ baseFontSize: 16,   // 1rem = 16px  │
      // │ 优点：适配2K/4K大屏，保持清晰度      │
      // └─────────────────────────────────────┘
      //
      // 【PX 转 REM 速查表 (baseFontSize=16)】
      // 8px=0.5rem  | 12px=0.75rem  | 14px=0.875rem
      // 16px=1rem   | 20px=1.25rem  | 24px=1.5rem
      // 28px=1.75rem| 32px=2rem     | 40px=2.5rem
      // 48px=3rem   | 64px=4rem     | 80px=5rem
      //
      // 【心算技巧】
      // 16px = 1rem, 8px = 0.5rem, 4px = 0.25rem
      // 例：36px = 32+4 = 2+0.25 = 2.25rem
      // 例：52px = 48+4 = 3+0.25 = 3.25rem
      //
      // 像素 / 16  XXXXXXXXXXX
      // ========================================================

      designWidth: 1920, // 设计稿宽度
      baseFontSize: 16, // 基准字体：1rem 在设计稿上对应的 px 值
      minScale: 0.5, // 最小缩放比例（防止手机字体过小）
      maxScale: 1, // 最大缩放比例（防止大屏字体过大）1.2  1.1
    };
  },
  mounted() {
    document.title = 'WONZ'; 
    this.calculateRootFontSize();
    window.addEventListener("resize", this.calculateRootFontSize);
    window.addEventListener("orientationchange", this.calculateRootFontSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateRootFontSize);
    window.removeEventListener("orientationchange", this.calculateRootFontSize);
  },
  methods: {
    /**
     * 根据屏幕宽度动态计算根字体大小
     *
     * 计算流程：
     * 1. 获取当前屏幕宽度
     * 2. 计算缩放比例 = 屏幕宽度 / 设计稿宽度
     * 3. 限制比例在 [minScale, maxScale] 范围内
     * 4. 根字体 = 基准字体 × 限制后的比例
     * 5. 设置到 html 元素，所有 rem 单位自动响应
     */
    calculateRootFontSize() {
      // const screenWidth = window.innerWidth;
      const screenWidth =
        document.documentElement.clientWidth || document.body.offsetWidth;
      let scale = 0;
      if (screenWidth > 767) {
        scale = screenWidth / this.designWidth;
      } else {
        scale = screenWidth / 750;
      }

      // 限制缩放比例范围，避免极端尺寸下显示异常
      const limitedScale = Math.max(
        this.minScale,
        Math.min(this.maxScale, scale)
      );

      // 计算最终根字体大小
      const rootFontSize = this.baseFontSize * limitedScale;

      // 设置到 html 元素（rem 的基准）
      document.documentElement.style.fontSize = rootFontSize + "px";
      // 开发环境输出调试信息
      // if (process.env.NODE_ENV === "development") {
      //   console.log("📐 响应式根字体计算:");
      //   console.log("   屏幕宽度:", screenWidth, "px", window.innerWidth);
      //   console.log("   设计稿宽度:", this.designWidth, "px");
      //   console.log("   原始比例:", scale.toFixed(4));
      //   console.log("   限制后比例:", limitedScale.toFixed(4));
      //   console.log("   基准字体:", this.baseFontSize, "px");
      //   console.log("   ✓ 根字体:", rootFontSize.toFixed(2), "px");
      //   console.log("   ✓ 1rem =", rootFontSize.toFixed(2), "px");
      //   console.log("─────────────────────────────");
      // }
    },
  },
};
</script>

<style>
/* ===== 全局重置 ===== */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
/* 全局/组件内样式（Vue 中加 scoped 需注意穿透） */
/* 1. Chrome/Edge/Opera 等 Webkit 内核浏览器 */
input[type="password"]::-webkit-reveal-button,
input[type="password"]::-webkit-credentials-auto-fill-button {
  /* 隐藏原生眼睛按钮 */
  display: none !important;
  /* 兜底：设为透明且宽高为0 */
  opacity: 0;
  width: 0;
  height: 0;
}

/* 2. Firefox 浏览器 */
input[type="password"] {
  /* 禁用 Firefox 密码框眼睛图标 */
  -moz-appearance: textfield !important;
  appearance: textfield !important;
}

/* 3. 兜底：禁用所有原生样式（可选） */
input[type="password"] {
  /* 去掉浏览器默认样式 */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: none; /* 可选：去掉聚焦外边框 */
}
input[type="password"]::-ms-reveal {
  display: none !important;
  visibility: hidden;
  width: 0;
  height: 0;
}
/* ===== 基础样式 ===== */
html {
  /* 默认值，会被 JS 动态覆盖 */
  font-size: 16px;
  /* 字体大小变化时平滑过渡 */
  /* transition: font-size 0.3s ease; */
  /* 防止 iOS 横屏时字体自动调整 */
  -webkit-text-size-adjust: 100%;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f5f7fa;
  /* 所有字体大小基于 rem，随根字体等比例缩放 */
  font-size: 1rem;
  line-height: 1.5;
  /* 防止水平滚动条 */
  overflow-x: hidden;
}

#app {
  width: 100%;
  min-height: 100vh;
  /* 确保内容在根字体变化时从顶部开始缩放 */
  transform-origin: top center;
}

/* ===== 通用工具类 ===== */
.container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 clamp(1rem, 3vw, 3rem);
}

/* ===== 滚动条美化 ===== */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* ===== 选中文字样式 ===== */
::selection {
  background: rgba(33, 150, 243, 0.2);
  color: #1976d2;
}

/* ===== 链接默认样式 ===== */
a {
  color: inherit;
  text-decoration: none;
}

/* ===== 按钮默认样式 ===== */
button {
  font-family: inherit;
  cursor: pointer;
  border: none;
  background: none;
}

/* ===== 输入框默认样式 ===== */
input,
textarea,
select {
  font-family: inherit;
  font-size: inherit;
  outline: none;
}

/* ===== 图片响应式 ===== */
img {
  max-width: 100%;
  height: auto;
  display: block;
}

/* ===== 打印样式 ===== */
@media print {
  html {
    font-size: 16px !important;
  }
  body {
    background: #fff;
  }
}

/* ===== 开发调试辅助（生产环境可删除）===== */
/*
【调试技巧】
在浏览器控制台输入以下代码查看当前 rem 值：
  
  // 查看当前根字体
  getComputedStyle(document.documentElement).fontSize
  
  // 测试 1rem 实际像素
  const test = document.createElement('div')
  test.style.width = '1rem'
  document.body.appendChild(test)
  console.log('1rem =', test.offsetWidth, 'px')
  document.body.removeChild(test)
*/
</style>